export default __webpack_public_path__ + "static/media/search_not_found_gray.311f27c7.svg";